import React from 'react';
import SEO from '../common/SEO';
import { FiEye, FiEyeOff, FiFacebook, FiInstagram, FiX } from 'react-icons/fi';
import Layout from '../common/Layout';
import { Link } from 'react-router-dom';
import Separator from '../separator/Separator';
import Amission from '../data/about/mission.json';
import Mission from '../elements/about/Mission';
import SectionTitle from '../elements/sectionTitle/SectionTitle';
import { GET_ROLE_DISPATCHING_BY_UNIT_SHORTNAME } from '../data/GraphHooks/useChapterMembers';
import Teamm from '../elements/team/teamm';
import { useQuery } from '@apollo/client';
import events from '../data/events';
import galleries from '../data/wie/gallery.ts';

const TMission = Amission[4];
const WieChapt = () => {
    const [eventsLimit, setEventsLimit] = React.useState(4);
    const [galleryLimit, setGalleryLimit] = React.useState(6);
    const [currentOpenEvent, setCurrentOpenEvent] = React.useState(null);

    const roleDispatching = useQuery(GET_ROLE_DISPATCHING_BY_UNIT_SHORTNAME, {
        variables: { unitShortname: 'WIE SAG' },
    });
    return (
        <>
            <SEO title="Wie Chapter IEEE ISSAT Sousse || Wie Chapter IEEE ISSATSo" />
            <main className="page-wrapper">
                <Layout>
                    {/* Start Slider Area  */}
                    <div className="slider-style-6 shape-left height-750 ">
                        <div className="container">
                            <div className="row row--30 align-items-center">
                                <div className="order-2 order-lg-1 col-lg-6 mt_md--50 mt_sm--50 mt_lg--30">
                                    <div className="inner text-left">
                                        <h1 className="title color-white">
                                            WIE Chapter
                                        </h1>
                                        <p className="description color-white">
                                            Women in Engineering.
                                        </p>
                                        <div className="button-group mt--30 mt_sm--20">
                                            <div className="flex items-center gap-12">
                                                <Link
                                                    target="_blank"
                                                    to={{
                                                        pathname:
                                                            'https://www.facebook.com/IEEE.WIE.ISSATSO.AG',
                                                    }}
                                                >
                                                    <FiFacebook />
                                                </Link>
                                                <Link
                                                    target="_blank"
                                                    to={{
                                                        pathname:
                                                            'https://www.instagram.com/ieeewieissatso/',
                                                    }}
                                                >
                                                    <FiInstagram />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 order-1 order-lg-2">
                                    <div className="thumbnail">
                                        <img
                                            src="./images/banner/wiebanner.png"
                                            alt="Banner Images"
                                        />
                                    </div>
                                </div>
                                <div className="shape-image">
                                    <img
                                        src="./images/banner/white-shape.svg"
                                        alt="Banner Images"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Slider Area  */}
                    <Separator />
                    <div className="rwt-team-area rn-section-gap">
                        <div className="wrapper plr--200 plr_sm--15">
                            <div className="row mb--20">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign="text-center"
                                        radiusRounded=""
                                        subtitle="Our WIE Team"
                                        title="Women In Engineering Board"
                                        description=""
                                    />
                                </div>
                            </div>
                            {roleDispatching.data && (
                                <Teamm
                                    column="col-lg-4 col-md-6 col-12"
                                    teamStyle="team-style-default style-two"
                                    data={roleDispatching.data.rd}
                                />
                            )}
                        </div>
                    </div>
                    <div className="rwt-timeline-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 offset-lg-12">
                                    <div className="col-lg-12 ">
                                        <Separator />
                                    </div>
                                    <Mission
                                        mainTitle={TMission.mainTitle}
                                        typedTitle={TMission.typedTitle}
                                        Paragraphe={TMission.Paragraphe}
                                        Paragraphe2={TMission.Paragraphe2}
                                        directlink={TMission.directlink}
                                        positionAccord={4}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Separator />
                    {/* events gallery section */}
                    <div className="container rn-section-gap">
                        <h3 className="mb-16">Gallery</h3>
                        <div className="grid grid-cols-3 gap-12">
                            {galleries.map((g, i) => {
                                return (
                                    <>
                                        {i < galleryLimit && (
                                            <div className="rounded-xl overflow-hidden relative group">
                                                <img
                                                    className="object-cover h-full object-fit"
                                                    src={g.image}
                                                    alt=""
                                                />
                                                {g.name && (
                                                    <div className="absolute inset-0 bg-black bg-opacity-50 flex-center flex-col text-center p-6 opacity-0 group-hover:opacity-100 duration-200">
                                                        <div className="text-white text-6xl font-bold">
                                                            {g.name}
                                                        </div>
                                                        <div className="mt-1 text-blue-300 font-medium text-xl">
                                                            {g.date}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                        </div>
                        <div className="mt-12 flex items-center justify-center">
                            {galleryLimit === 6 && (
                                <button
                                    className="btn btn-lg btn-default !flex items-center"
                                    onClick={() => setGalleryLimit(99)}
                                >
                                    <FiEye className="mr-2" />
                                    <span>Show more</span>
                                </button>
                            )}
                            {galleryLimit === 99 && (
                                <button
                                    className="btn btn-lg btn-default !flex items-center"
                                    onClick={() => setGalleryLimit(6)}
                                >
                                    <FiEyeOff className="mr-2" />
                                    <span>Show less</span>
                                </button>
                            )}
                        </div>
                    </div>
                    <Separator />
                    {/* events articles section */}
                    <div className="container rn-section-gap">
                        <h3 className="mb-0">Events</h3>
                        <p>Our latest events.</p>
                        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-9">
                            {/* events loop */}
                            {events.map((event, index) => (
                                <>
                                    {index < eventsLimit && (
                                        <div
                                            className="bg-blue-50 rounded-xl overflow-hidden clickable-card self-center justify-self-center items-center w-full"
                                            onClick={() =>
                                                setCurrentOpenEvent(event)
                                            }
                                        >
                                            <div className="h-[256px] w-full bg-gray-600 overflow-hidden flex-center">
                                                {event.image && (
                                                    <img
                                                        src={event.image}
                                                        alt=""
                                                        className="w-full h-full object-cover"
                                                    />
                                                )}
                                                {!event.image && (
                                                    <div className="text-white text-7xl font-bold">
                                                        {event.title[0]}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="p-8">
                                                {event.date && (
                                                    <div className="text-xl font-medium text-gray-400 mb-4">
                                                        {event.date}
                                                    </div>
                                                )}
                                                <div className="font-bold text-black text-3xl">
                                                    {event.title}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            ))}
                        </div>
                        <div className="mt-12 flex-center">
                            {eventsLimit === events.length ? (
                                <button
                                    onClick={() => setEventsLimit(4)}
                                    className="btn btn-lg btn-default !flex items-center"
                                >
                                    <FiEyeOff className="mr-2" />
                                    <span>Show less</span>
                                </button>
                            ) : (
                                <button
                                    onClick={() =>
                                        setEventsLimit(events.length)
                                    }
                                    className="btn btn-lg btn-default !flex items-center"
                                >
                                    <FiEye className="mr-2" />
                                    <span>Show more</span>
                                </button>
                            )}
                        </div>
                    </div>
                </Layout>

                {/* current open event detail modal */}
                {currentOpenEvent && (
                    <div className="fixed top-0 left-0 min-vh-100 w-full bg-gray-500 bg-opacity-80 flex-center">
                        <div
                            className="m-20 max-h-[80vh] bg-white rounded-xl overflow-y-scroll max-w-7xl shadow-lg"
                            onClick={() => {}}
                        >
                            {currentOpenEvent.image && (
                                <img src={currentOpenEvent.image} alt="" />
                            )}
                            <div className="p-8">
                                <h2 className="mb-0">
                                    {currentOpenEvent.title}
                                </h2>
                                {currentOpenEvent && (
                                    <p className="text-lg font-medium !text-blue-500">
                                        {currentOpenEvent.date}
                                    </p>
                                )}
                                <p
                                    className="text-gray-700 my-0"
                                    dangerouslySetInnerHTML={{
                                        __html: currentOpenEvent.content,
                                    }}
                                />
                                <div className="mt-10 flex justify-end">
                                    <button
                                        className="btn btn-danger"
                                        onClick={() =>
                                            setCurrentOpenEvent(null)
                                        }
                                    >
                                        <FiX className="h-6 w-6" /> Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </>
    );
};

export default WieChapt;
